import React from 'react';
export function SolutionSection() {
  return <section className="py-12 bg-main overflow-hidden" data-id="element-166">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-167">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-168">
          <div data-id="element-169">
            <h2 className="text-3xl md:text-5xl font-serif mb-6 leading-tight text-title" data-id="element-170">
              Gana sin ser vista.
            </h2>
            <p className="text-body text-lg mb-4 leading-relaxed" data-id="element-171">
              Las cuentas que más crecen hoy no venden una persona. Venden una
              estética + una solución.
            </p>
            <p className="text-body text-lg mb-8 leading-relaxed" data-id="element-172">
              Sin mostrar tu cara, sin bailar y sin convertir tu vida privada en
              contenido.
            </p>
            <div className="p-6 bg-alt border-l-4 border-accent" data-id="element-173">
              <p className="font-serif text-lg italic text-title" data-id="element-174">
                "La era de vender tu vida privada terminó. Ahora gana quien
                tiene método."
              </p>
              <p className="mt-3 text-sm font-sans text-accent not-italic" data-id="element-175">
                — Método Faceless Spain
              </p>
            </div>

            <div className="mt-8" data-id="element-176">
              <p className="text-sm font-semibold text-title uppercase tracking-widest mb-4" data-id="element-177">
                Cómo funciona (en simple):
              </p>
              <ul className="space-y-3 text-body text-sm" data-id="element-178">
                <li className="flex items-start" data-id="element-179">
                  <span className="text-accent font-serif font-bold mr-3 mt-0.5" data-id="element-180">
                    1.
                  </span>
                  <span data-id="element-181">Eliges una estética y un ángulo (sin exponerte)</span>
                </li>
                <li className="flex items-start" data-id="element-182">
                  <span className="text-accent font-serif font-bold mr-3 mt-0.5" data-id="element-183">
                    2.
                  </span>
                  <span data-id="element-184">
                    Publicas contenido faceless (sin quedarte en blanco)
                  </span>
                </li>
                <li className="flex items-start" data-id="element-185">
                  <span className="text-accent font-serif font-bold mr-3 mt-0.5" data-id="element-186">
                    3.
                  </span>
                  <span data-id="element-187">
                    Monetizas con una estructura clara (sin improvisar)
                  </span>
                </li>
              </ul>
            </div>
          </div>

          <div className="relative" data-id="element-188">
            <div className="space-y-8" data-id="element-189">
              <div className="bg-card p-8 border border-[#E7D8C8] relative" data-id="element-190">
                <span className="absolute -top-4 -left-4 w-10 h-10 bg-accent text-white flex items-center justify-center font-serif text-lg font-bold" data-id="element-191">
                  01
                </span>
                <h4 className="font-serif text-xl mb-2 text-title ml-4" data-id="element-192">
                  Anonimato es poder
                </h4>
                <p className="text-body text-sm ml-4" data-id="element-193">
                  Construyes una marca que funciona sin depender de tu imagen.
                </p>
              </div>

              <div className="bg-card p-8 border border-[#E7D8C8] relative ml-4 md:ml-8" data-id="element-194">
                <span className="absolute -top-4 -left-4 w-10 h-10 bg-accent text-white flex items-center justify-center font-serif text-lg font-bold" data-id="element-195">
                  02
                </span>
                <h4 className="font-serif text-xl mb-2 text-title ml-4" data-id="element-196">
                  Contenido faceless (sin complicarte)
                </h4>
                <p className="text-body text-sm ml-4" data-id="element-197">
                  Aprendes qué tipos de videos/fotos funcionan sin mostrar
                  rostro y cómo adaptarlos a tu estilo.
                </p>
              </div>

              <div className="bg-card p-8 border border-[#E7D8C8] relative ml-8 md:ml-16" data-id="element-198">
                <span className="absolute -top-4 -left-4 w-10 h-10 bg-accent text-white flex items-center justify-center font-serif text-lg font-bold" data-id="element-199">
                  03
                </span>
                <h4 className="font-serif text-xl mb-2 text-title ml-4" data-id="element-200">
                  Estructura que convierte
                </h4>
                <p className="text-body text-sm ml-4" data-id="element-201">
                  Publicas con intención: perfil, mensajes y contenido alineados
                  para que la gente entienda y confíe.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}